export const MODULE_FIELDS = `
  id
  organizationId
  organization {
    id
    name
  }
  allAccounts
  accounts {
    account {
      id
      name
    }
  }
  name
  entityName
  pluralEntityName
  status
  fields {
    name
    handle
    displayOrder
    type
    status
    description
    placeholder
    defaultValue
    options
    multiline
    validateRequired
    validateUnique
    onlyShowAfterRecordCreated
    validateRegex
    validateMinLength
    validateMaxLength
    validateMinDate
    validateMaxDate
    validateDate
    validateDateRelative
  }
  createItemsRoles
  editItemsRoles
  deleteItemsRoles
  createdAt
  updatedAt
`

export const GET_MODULES = gql`
  query ModulesQuery ($status: String, $ids: [String!], $page: Int, $perPage: Int) {
    modules(status: $status, ids: $ids, page: $page, perPage: $perPage) {
      modules {
        ${MODULE_FIELDS}
      }
      total
      hasNextPage
      hasPreviousPage
    }
  }
`

export const CREATE_MODULE_MUTATION = gql`
  mutation createModule($input: ModuleInput!) {
    createModule(input: $input) {
      id
      userErrors {
        field
        message
      }
    }
  }
`

export const UPDATE_MODULE_MUTATION = gql`
  mutation updateModule($id: String!, $input: ModuleInput!) {
    updateModule(id: $id, input: $input) {
      ${MODULE_FIELDS}
    }
  }
`

export const DELETE_MODULE_MUTATION = gql`
  mutation deleteModule($id: String!) {
    deleteModule(id: $id) {
      id
    }
  }
`

export const ASSOCIATE_MODULE_ITEMS_QUERY = gql`
  query AssociateModuleItemsQuery(
    $moduleId: String!
    $associateId: String!
    $status: String
    $page: Int
    $perPage: Int
  ) {
    module(id: $moduleId) {
      id
      itemsPage(
        associateId: $associateId
        status: $status
        page: $page
        perPage: $perPage
      ) {
        module {
          id
          name
          createItemsRoles
          editItemsRoles
          deleteItemsRoles
        }
        items {
          id
          deletedAt
          archivedAt
          createdAt
          updatedAt
          deletedByUser {
            id
            name
          }
          archivedByUser {
            id
            name
          }
          fields {
            handle
            value
            values
          }
        }
        total
        hasNextPage
        hasPreviousPage
      }
    }
  }
`

export const CREATE_MODULE_ITEM_MUTATION = gql`
  mutation createModuleItem($input: ModuleItemInput!) {
    createModuleItem(input: $input) {
      id
      userErrors {
        field
        message
      }
    }
  }
`

export const UPDATE_MODULE_ITEM_MUTATION = gql`
  mutation updateModuleItem($id: String!, $input: ModuleItemInput!) {
    updateModuleItem(id: $id, input: $input) {
      id
      userErrors {
        field
        message
      }
    }
  }
`

export const DELETE_MODULE_ITEM_MUTATION = gql`
  mutation deleteModuleItem($id: String!) {
    deleteModuleItem(id: $id) {
      id
    }
  }
`

export const ARCHIVE_MODULE_ITEM_MUTATION = gql`
  mutation archiveModuleItem($id: String!) {
    archiveModuleItem(id: $id) {
      id
    }
  }
`

export const UNARCHIVE_MODULE_ITEM_MUTATION = gql`
  mutation unarchiveModuleItem($id: String!) {
    unarchiveModuleItem(id: $id) {
      id
    }
  }
`
